import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Radio as BaseRadio } from '@alfa-bank/site-radio/radio';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import type { TFormRadio, IDeps } from './models';
import { FormRadio as Component } from './form-radio';

export const FormRadio = createWidget<IDeps, TFormRadio>({
    Field,
    BaseRadio,
})(Component);
